import React from "react";
import VersionedLegalDocument from "./VersionedLegalDocument";

export default function ModerationPolicy() {
  return <VersionedLegalDocument documentType="moderation_policy" />;
}
